import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/about/techny-oval-speech-bubble-1 1.png")